/**
 * R7E custom settings
 *
 * Override these values for your deployment to control registration modes
 * and other app-specific behavior.
 */
export const r7eSettings = {
    registration: {
        all: {
            registrationByInvitationEnabled: true,
            registrationByWaitingListEnabled: true,
            registrationByEmailEnabled: false,
        },
        publisher: {
            registrationByInvitationEnabled: true,
            registrationByWaitingListEnabled: true,
            registrationByEmailEnabled: false,
        },
        author: {
            registrationByInvitationEnabled: true,
            registrationByWaitingListEnabled: true,
            registrationByEmailEnabled: false,
        },
        consumer: {
            registrationByInvitationEnabled: true,
            registrationByWaitingListEnabled: true,
            registrationByEmailEnabled: true,
        }
    },
    waitingList: {
        minTotal: 5,
    }
};
